import React, { useContext, useEffect, useState } from "react";
import {Breadcrumb, Button, ButtonGroup, ButtonGroupItem} from "@boozallen-uip/uswds-react-core";
import { SectionContainer, SectionSubHeader } from "../../shared.styled";
import isTokenValid from "../../../utlities/auth.utility";
import ProductTableContainer from "./ProductTableContainer.component";
import PageHeader from "../../../components/PageHeader/PageHeader.component";
import { UserContext } from "../../UserContext";
import {FOR_BUYERS_URL, HOME_URL} from "../../../utlities/core.constants";
import { useLoginModal } from "../../../components/modals/LoginModalContext";

export default function ProductListUnauthorized() {
  const [isAuthenticated, setIsAuthenticated] = useState();
  const { token } = useContext(UserContext);
  const { openLoginModal, isLoginModalOpen } = useLoginModal();
  // eslint-disable-next-line class-methods-use-this

  useEffect(() => {
    setIsAuthenticated(isTokenValid(token))
  }, [token])

  return (
    <div>
    <PageHeader imageUrl="/page-banners/BuyerBannerImg.png" backgroundSize='1200px 180px' backgroundPosition='right' backgroundColor="var(--color-primary)">
      ACR Repository for Buyers
    </PageHeader>
      <SectionContainer>
        <div className='text-primary-darker'>
          <Breadcrumb links={[{"href": HOME_URL, "text": "Home"}, {"href": FOR_BUYERS_URL, "text": "For Buyers"}]} />
        </div>
        <div>
          <h1 className="text-primary text-3xl font-normal">Find ACRs listed in ACR Repository</h1>
          <SectionSubHeader className='font-normal'>ACR Repository lists detailed product accessibility info, vital for compliance and user inclusivity.</SectionSubHeader>
          <p className='leading-normal'>
            To access comprehensive details about product accessibility for items listed in the ACR Repository, users are required to log in. This secure login ensures that sensitive and detailed information about product compliance and features remains protected and accessible only to authorized users. Logging in allows you to fully explore and utilize the available resources to assess product accessibility effectively.
          </p>
        </div>
        <div>
          {isAuthenticated ? null :
            <ButtonGroup className="pb-4">
              <ButtonGroupItem>
                <Button onClick={openLoginModal} aria-haspopup="dialog" aria-controls="login-modal" aria-expanded={isLoginModalOpen}>Log in to your dashboard</Button>
              </ButtonGroupItem>
            </ButtonGroup>}
        </div>
        <div>
          <SectionSubHeader>ACR Repository Product Listings</SectionSubHeader>
          <p className='leading-normal pb-4'>
          Use the filters below to narrow down your search. You can apply several filters at a time, as well as filter by the different categories at the same time. Once filters are applied, you can remove them by clicking on the “X” next to each filter name.
          </p>
        </div>
        <ProductTableContainer />
      </SectionContainer>
    </div>
  );
}
